import React from 'react';
import { Col, Row } from 'react-bootstrap';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import Navbar from '../navigation/navbar';
import ChangeEmailLandingPage from './change-email-link-page';
import { connect as connectR } from 'react-redux';
import translate from '../translate';
import TitleCard from '../main/title-card';

interface Props {
    strings: {
        cancel: string;
        sideTitle: string;
    };
}

interface State {}

class ChangeEmailLandingPageWrapper extends React.Component<Props, State> {
    render() {
        const getBackArrow = () => ({
            content: '',
            title: this.props.strings.cancel,
        });
        return (
            <Navbar>
                <Row>
                    <LeftSide addClass="">
                        <TitleCard
                            title={[this.props.strings.sideTitle]}
                            left={getBackArrow()}
                        />
                    </LeftSide>
                    <Col xs={6} className={'col-middle'}>
                        <ChangeEmailLandingPage {...this.props} />
                    </Col>
                    <RightSide></RightSide>
                </Row>
            </Navbar>
        );
    }
}

export default connectR()(
    translate('ChangeEmailLandingPage')(ChangeEmailLandingPageWrapper)
);
